type Turnstile = {
  render: (element: HTMLElement, options: Record<string, unknown>) => string;
  remove: (id: string) => void;
};
declare global { interface Window { turnstile?: Turnstile } }

const guarded = /^\/api\/(?:accounts\/(?:register|password-reset\/request)|marketing\/subscribe|contact|bookings|chat\/conversations(?:\/[^/]+\/messages)?)\/?$/;
let scriptPromise: Promise<void> | undefined;
async function challenge(sitekey: string): Promise<string> {
  if (!window.turnstile) {
    scriptPromise ??= new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.onload = () => resolve();
      script.onerror = () => { scriptPromise = undefined; reject(new Error("Verification is unavailable. Please try again.")); };
      document.head.append(script);
    });
    await scriptPromise;
  }
  return new Promise((resolve, reject) => {
    const dialog = document.createElement("dialog");
    dialog.setAttribute("aria-label", "Verify your submission");
    const heading = document.createElement("h2"); heading.textContent = "Verify your submission";
    const widget = document.createElement("div");
    const cancel = document.createElement("button"); cancel.textContent = "Cancel"; cancel.type = "button";
    dialog.append(heading, widget, cancel); document.body.append(dialog); dialog.showModal();
    let widgetId: string | undefined;
    const finish = (token?: string) => {
      if (widgetId) window.turnstile?.remove(widgetId);
      dialog.remove();
      if (token) resolve(token); else reject(new Error("Verification was cancelled or expired. Please try again."));
    };
    cancel.onclick = () => finish(); dialog.oncancel = () => finish();
    widgetId = window.turnstile!.render(widget, { sitekey, action: "public_submission", callback: finish,
      "error-callback": () => finish(), "expired-callback": () => finish() });
  });
}

export async function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const path = typeof input === "string" ? input.split("?")[0] : "";
  if (init?.method?.toUpperCase() !== "POST" || !guarded.test(path)) return fetch(input, init);
  const response = await fetch("/api/security/config");
  const config = await response.json();
  if (!response.ok || !config.submissionsEnabled) throw new Error("Online submissions are temporarily unavailable. Please contact us by phone.");
  const token = await challenge(config.siteKey);
  return fetch(input, { ...init, body: JSON.stringify({ ...JSON.parse(String(init.body || "{}")), captchaToken: token }) });
}
